import { Module } from 'vuex'

class ContractState {
  items: Record<string, any> = {}
  selectItem: Record<string, any> = {}
  signList: Array<any> = []
  originSignList: Array<any> = []
  pdfUrl: any = ''
  pdfUrlModify: any = false
  originContractDetail: Record<string, any> = {}
}

const app: Module<ContractState, unknown> = {
  namespaced: true,
  state: new ContractState(),
  mutations: {
    setSelectItem(state: ContractState, items: Record<string, any> = {}) {
      state.selectItem = items
    },
    setSignList(state: ContractState, items: Array<any> = []) {
      state.signList = items
    },
    setPdfUrl(state: ContractState, items: any) {
      state.pdfUrl = items
    },
    setPdfUrlModify(state: ContractState, items: any) {
      state.pdfUrlModify = items
    },
    setOriginSignList(state: ContractState, items: any) {
      state.originSignList = items
    },
    setOriginContractDetail(state: ContractState, items: any) {
      state.originContractDetail = items
    },
    initSignInfo(state: ContractState, items: any) {
      state.items = {}
      state.selectItem = {}
      state.signList = []
      state.originSignList = []
      state.pdfUrl = ''
      state.pdfUrlModify = false
    }
  }
}

export default app
